import { render, staticRenderFns } from "./one-drive-file-access-action-output.vue?vue&type=template&id=99875862&scoped=true"
import script from "./one-drive-file-access-action-output.vue?vue&type=script&lang=js"
export * from "./one-drive-file-access-action-output.vue?vue&type=script&lang=js"
import style0 from "./one-drive-file-access-action-output.vue?vue&type=style&index=0&id=99875862&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99875862",
  null
  
)

export default component.exports